import { useEffect, useRef, useState } from 'react'
import { ChartFlipper } from '../chart-flipper'
import { Legend } from '../common/legend/legend'
import { LineChartWithTooltip } from './line-chart-with-tooltip'
import { lineColorService } from './line-color.service'
import { lineDataService } from './line-data.service'

export const LineBlockSingle = function ({
  dataKey,
  chartData,
  tableData,
  showTableToggle,
  showTable,
  legendToggles,
  onLegendToggle,
  tableProps,
  ...props
}) {
  const [colors, setColors] = useState([])
  const seriesColorCache = useRef({})
  const nextColorIndex = useRef(0)

  useEffect(() => {
    const { nextIndex, colors } = lineColorService.setChartColors(chartData, seriesColorCache.current, nextColorIndex.current)
    nextColorIndex.current = nextIndex
    setColors(colors)
  }, [ chartData ])

  if (!chartData) {
    return null
  }

  const legendLabels = chartData.map((s) => s.label || s.name)
  const filteredChartData = lineDataService.filterToggledChartSeries(chartData, legendToggles)
  const filteredTableData = lineDataService.filterToggledTableColumns(tableData, legendToggles)

  return (
    <ChartFlipper
      dataKey={dataKey}
      enabled={showTableToggle}
      showTable={showTable}
      tableData={filteredTableData}
      tableProps={tableProps}
    >
      <Legend
        labels={legendLabels}
        colors={colors}
        toggleDefaults={legendToggles}
        onToggle={onLegendToggle}
      />
      {filteredChartData && (
        <LineChartWithTooltip
          series={filteredChartData}
          colors={colors}
          legendToggles={legendToggles}
          {...props}
        />
      )}
    </ChartFlipper>
  )
}
